/** @format */
import { FunctionComponent } from 'react';

import { MarketCode } from '@toucan/config/markets';

import ATFlag from '@toucan/images/flag-at.svg';
import BEFlag from '@toucan/images/flag-be.svg';
import DEFlag from '@toucan/images/flag-de.svg';
import ESFlag from '@toucan/images/flag-es.svg';
import EUFlag from '@toucan/images/flag-eu.svg';
import FRFlag from '@toucan/images/flag-fr.svg';
import IEFlag from '@toucan/images/flag-ie.svg';
import ITFlag from '@toucan/images/flag-it.svg';
import NLFlag from '@toucan/images/flag-nl.svg';
import PTFlag from '@toucan/images/flag-pt.svg';
import UKFlag from '@toucan/images/flag-uk.svg';
import USFlag from '@toucan/images/flag-us.svg';

export const flags: Record<
    MarketCode,
    FunctionComponent<{ className?: string }>
> = {
    [MarketCode.EN_UK]: UKFlag,
    [MarketCode.EN_US]: USFlag,
    [MarketCode.DE_DE]: DEFlag,
    [MarketCode.FR_FR]: FRFlag,
    [MarketCode.EN_EU]: EUFlag,
    [MarketCode.NL_NL]: NLFlag,
    [MarketCode.IT_IT]: ITFlag,
    [MarketCode.DE_AT]: ATFlag,
    [MarketCode.FR_BE]: BEFlag,
    [MarketCode.NL_BE]: BEFlag,
    [MarketCode.EN_IE]: IEFlag,
    [MarketCode.PT_PT]: PTFlag,
    [MarketCode.ES_ES]: ESFlag,
};
